import React from 'react';
import { Card, Space, Typography } from 'antd';
import { DiffOutlined } from '@ant-design/icons';
import { resolvePatchPreviewViewModel } from './messagePatchPreviewModel.js';

const { Paragraph, Text } = Typography;

export function MessagePatchPreviewCard({
  item = {},
  themeTokens,
}) {
  const { changes, summary } = resolvePatchPreviewViewModel(item.payload);

  return (
    <Card
      size="small"
      style={{
        background: themeTokens?.surfaceBg,
        borderColor: themeTokens?.surfaceBorder,
      }}
    >
      <Space orientation="vertical" size={8} style={{ width: '100%' }}>
        <Space align="center" size={8}>
          <DiffOutlined />
          <Text strong style={{ color: themeTokens?.textPrimary }}>修改预览（尚未应用）</Text>
        </Space>
        <Paragraph style={{ color: themeTokens?.textPrimary, marginBottom: 0 }}>
          {summary}
        </Paragraph>
        {changes.map((change, index) => (
          <Space key={`patch-change-${index}`} orientation="vertical" size={4} style={{ width: '100%' }}>
            {change.before ? (
              <div style={{ background: '#fff1f0', borderRadius: 6, padding: '8px 10px', whiteSpace: 'pre-wrap' }}>
                <Text type="secondary">原内容</Text>
                <div style={{ color: themeTokens?.textPrimary }}>{change.before}</div>
              </div>
            ) : null}
            {change.after ? (
              <div style={{ background: '#f6ffed', borderRadius: 6, padding: '8px 10px', whiteSpace: 'pre-wrap' }}>
                <Text type="secondary">修改为</Text>
                <div style={{ color: themeTokens?.textPrimary }}>{change.after}</div>
              </div>
            ) : null}
          </Space>
        ))}
      </Space>
    </Card>
  );
}

export default MessagePatchPreviewCard;
